import React from "react";
import { Box, TextField, Typography } from "@mui/material";

const Motivational = ({ formik }) => {
  return (
    <>
      <Box sx={{ marginBottom: "20px" }}>
        <Typography variant="h4">Acumen Test</Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <Typography variant="h6">
            Why do you want to apply for financial aid and how will the
            financial aid help you? NB: Use of AI would lead to automatic disqualification. 
          </Typography>
          <TextField
            name="motivation"
            value={formik.values.motivation}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            variant="outlined"
            multiline
            rows={2}
            autoFocus
          />
          {formik.touched.motivation && formik.errors.motivation ? (
            <Typography sx={{ color: "#ff0000" }}>
              {formik.errors.motivation}
            </Typography>
          ) : (
            ""
          )}
        </Box>
      </Box>
    </>
  );
};

export default Motivational;
